/* import __COLOCATED_TEMPLATE__ from './new-password-form.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';
import { passwordValidator, confirmPasswordValidator } from 'sh-www/utils/validators';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';

export default class NewPasswordForm extends Component {
  @service('error-tracker') errorTracker;
  @service session;

  @tracked errors = {};
  @tracked password = '';
  @tracked newPassword = '';
  @tracked newPasswordConfirmation = '';

  @action
  updateField(field, value) {
    this[field] = value;
    delete this.errors[field];
    this.errors = this.errors;
  }

  @action
  validateCurrentPassword() {
    if (!this.password && this.session.currentUser.hasPassword) {
      this.errors['password'] = 'Current password is a required field';
    } else {
      delete this.errors['password'];
    }
    this.errors = this.errors;
  }

  @action
  validateNewPassword() {
    const newPasswordError = passwordValidator(this.newPassword);
    if (newPasswordError) {
      this.errors['newPassword'] = newPasswordError;
    } else {
      delete this.errors['newPassword'];
    }
    this.errors = this.errors;
  }

  @action
  validateNewPasswordConfirmation() {
    const confirmPasswordError = confirmPasswordValidator(this.newPassword, this.newPasswordConfirmation);
    if (confirmPasswordError) {
      this.errors['newPasswordConfirmation'] = confirmPasswordError;
    } else {
      delete this.errors['newPasswordConfirmation'];
    }
    this.errors = this.errors;
  }

  @task
  *handleSubmit() {
    if (this.args.saving) {
      return;
    }

    this.errors = {};
    this.validateCurrentPassword();
    this.validateNewPassword();
    this.validateNewPasswordConfirmation();

    if (Object.keys(this.errors).length > 0) {
      return;
    }

    try {
      yield this.args.resetPassword(this.newPassword, this.newPasswordConfirmation, this.password);
    } catch (e) {
      if (e.status === 401) {
        this.errors.password = e.errors['generic-exception'];
        this.errors = this.errors;
      } else {
        handleErrorResponse(this, e, [
          'generic-exception',
          'password',
          'newPassword',
        ]);
      }
    }

    this.password = null;
    this.newPassword = null;
    this.newPasswordConfirmation = null;
  }
}
